// Please keep the routes in alphabetical order

export const apiAddDocumentJourneyStepPath = (companyId, journeyId) =>
  `/api/companies/${companyId}/journeys/${journeyId}/journey_steps/add_document`

export const apiAddKnowledgeCheckTrainingJourneyStepPath = (companyId, journeyId) =>
  `/api/companies/${companyId}/journeys/${journeyId}/journey_steps/add_knowledge_check_training`

export const apiAddLinkJourneyStepPath = (companyId, journeyId) =>
  `/api/companies/${companyId}/journeys/${journeyId}/journey_steps/add_link`

export const apiAddVideoTrainingJourneyStepPath = (companyId, journeyId) =>
  `/api/companies/${companyId}/journeys/${journeyId}/journey_steps/add_video_training`

export const apiAgentsAssistantsPath = () => `/api/agents/assistants`

export const apiAgentsConversationsPath = () => `/api/agents/conversations`

export const apiAgentsConversationPath = (conversationId) =>
  `/api/agents/conversations/${conversationId}`

export const apiArchiveGroupPath = (companyId, groupId) => 
  `/api/companies/${companyId}/groups/${groupId}`

export const apiArchiveBulkGroupsPath = (companyId) =>
  `/api/companies/${companyId}/bulk_groups/archive`

export const apiAgentsConversationMessagesPath = (conversationId) =>
  `/api/agents/conversations/${conversationId}/messages`

export const apiAgentsConversationAssistantPath = (conversationId) =>
  `/api/agents/conversations/${conversationId}/assistant`

export const apiAgentsReportExportsPath = () => `/api/agents/report_exports`

export const apiAgentsReportSavesPath = () => `/api/agents/report_saves`

export const apiAgentsWidgetActionsSaveToCurrentDashboardPath = () => `/api/agents/widget_actions/save_to_current_dashboard`

export const apiAgentsWidgetActionsSaveToNewDashboardPath = () => `/api/agents/widget_actions/save_to_new_dashboard`

export const apiAgentsWidgetActionsExportCsvPath = () => `/api/agents/widget_actions/export_csv`

export const apiAddCoursesJourneyStepPath = (companyId, journeyId) =>
  `/api/companies/${companyId}/journeys/${journeyId}/journey_steps/add_courses`

export const apiAssignLearnersToClassroomPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/classrooms`

export const apiAssignLearnersToPhishingCampaignPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/phishing_campaigns`

export const apiAllowOrDisableSelfEnrolePath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/self_enroll`

export const apiAuthenticationSettingsPath = companyId =>
  `/api/companies/${companyId}/authentication_settings`

export const apiBulkUpdateDashboardWidgetsPath = companyId =>
  `/api/companies/${companyId}/insights/dashboard_widgets/bulk_update`

export const apiCompanyContactsPath = companyId => `/api/companies/${companyId}/company_contacts`

export const apiCreateKioskLinkPath = companyId => `/api/companies/${companyId}/kiosk_links`

export const apiExportLearnersPath = companyId => `/api/companies/${companyId}/learners/export`

export const apiKioskLinkDownloadPosterPath = (companyId, kioskLinkId) =>
  `/companies/${companyId}/kiosk_links/${kioskLinkId}/download_poster`

export const apiKioskLinkPath = (companyId, kioskLinkId) =>
  `/api/companies/${companyId}/kiosk_links/${kioskLinkId}`

export const apiAssignJourneyStepToLearnerPath = (companyId, learnerId) =>
  `/api/companies/${companyId}/journey_learners/${learnerId}/assign`

export const apiCompanyIntegrationAccessTokenPath = (companyId, integrationId, accessTokenId) =>
  `${apiCompanyIntegrationAccessTokensPath(companyId, integrationId)}/${accessTokenId}`

export const apiCompanyIntegrationAccessTokensPath = (companyId, integrationId) =>
  `${apiCompanyIntegrationPath(companyId, integrationId)}/access_tokens`

export const apiCompanyIntegrationCardsPath = companyId =>
  `${apiCompanyIntegrationsPath(companyId)}/cards`

export const apiCompanyIntegrationCredentialsPath = (companyId, integrationId) =>
  `${apiCompanyIntegrationPath(companyId, integrationId)}/credentials`

export const apiCompanyIntegrationPath = (companyId, integrationId) =>
  `${apiCompanyIntegrationsPath(companyId)}/${integrationId}`

export const apiCompanyIntegrationReconnectPath = (companyId, integrationId) =>
  `${apiCompanyIntegrationPath(companyId, integrationId)}/reconnect`

export const apiCompanyIntegrationRefreshSyncPath = (companyId, integrationId) =>
  `${apiCompanyIntegrationPath(companyId, integrationId)}/refresh_sync`

export const apiCompanyIntegrationSetupPath = (companyId, integrationId) =>
  `${apiCompanyIntegrationPath(companyId, integrationId)}/setup`

export const apiCompanyIntegrationSettingsPath = (companyId, integrationId) =>
  `${apiCompanyIntegrationPath(companyId, integrationId)}/settings`

export const apiCompanyIntegrationSyncPath = (companyId, integrationId) =>
  `${apiCompanyIntegrationPath(companyId, integrationId)}/sync`

export const apiCompanyIntegrationSyncStatusPath = (companyId, integrationId) =>
  `${apiCompanyIntegrationPath(companyId, integrationId)}/sync_status`

export const apiCompanyIntegrationTogglePath = (companyId, integrationId) =>
  `${apiCompanyIntegrationPath(companyId, integrationId)}/toggle`

export const apiCompanyIntegrationsPath = companyId =>
  `/api/companies/${companyId}/integrations`

export const apiCompanyGoogleDmiSendTestEmailPath = companyId =>
  `/api/companies/${companyId}/google_dmi/send_test_email`

export const apiCompanySalesforcePath = (companyId, integrationId) =>
  `/api/companies/${companyId}/salesforce/${integrationId}`

export const apiCompanyUserPath = (companyId, userId) =>
  `/api/companies/${companyId}/users/${userId}`

export const apiCompanyDataReportsPath = companyId =>
  `/api/companies/${companyId}/data_reports`

export const apiCompanyDataReportPath = (companyId, reportId) =>
  `/api/companies/${companyId}/data_reports/${reportId}`

export const apiDuplicateCompanyDataReportPath = (companyId, reportId) =>
  `/api/companies/${companyId}/data_reports/${reportId}/duplicate`

export const apiCompanyDataReportsSchedulesPath = companyId =>
  `/api/companies/${companyId}/data_reports_schedules`

export const apiCompanyDataReportsSchedulePath = (companyId, scheduleId) =>
  `/api/companies/${companyId}/data_reports_schedules/${scheduleId}`

export const apiCompanyUsersPath = companyId =>
  `/api/companies/${companyId}/company_users`

export const apiCompanyUserRecordPath = (companyId, companyUserId) =>
  `/api/companies/${companyId}/company_users/${companyUserId}`

export const apiSetPrimaryCompanyUserPath = (companyId, companyUserId) =>
  `${apiCompanyUserRecordPath(companyId, companyUserId)}/primary`

export const apiCompanyLearnerGroupsPath = (companyId, journeyId) =>
  `/api/companies/${companyId}/journeys/${journeyId}/learner_groups`

export const apiCompanyPoliciesPath = companyId => `/api/companies/${companyId}/policies`

export const apiDownloadCertificatePath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/download_certificates`

export const apiFetchAssignableCampaignsPath = companyId => `/api/companies/${companyId}/campaigns`

export const apiFetchGroupMembersPath = (companyId, groupId) =>
  `/api/companies/${companyId}/groups/${groupId}/edit_learners`

export const apiFetchMandatedInsightsPath = (companyId, learnerId) =>
  `/api/companies/${companyId}/learners/${learnerId}/mandated_insights`

export const apiFetchRequiredTrainingsPath = companyId =>
  `/api/companies/${companyId}/trainings/mandated_insights`

export const apiFetchInvoicesPath = companyId =>
  `/api/companies/${companyId}/invoices`

export const apiActiveSubscriptionPath = companyId =>
  `/api/companies/${companyId}/subscriptions/active`

export const apiFetchSubscriptionEstimationPath = companyId =>
  `/api/companies/${companyId}/subscriptions/estimate`

export const apiSubscriptionPlansPath = companyId =>
  `/api/companies/${companyId}/subscriptions/plans`

export const apiSubscriptionQuickbooksCallbackPath = (companyId, subscriptionId) =>
  `/api/companies/${companyId}/subscriptions/${subscriptionId}/quickbooks_callback`

export const apiSubaccountsPath = companyId =>
  `/api/companies/${companyId}/subaccounts`

export const apiAccountsPath = () => `/api/companies`

export const apiSubscriptionsPath = companyId =>
  `/api/companies/${companyId}/subscriptions`

export const apiSuggestedLearnersPath = companyId =>
  `/api/companies/${companyId}/suggested_learners`

export const apiSuggestionOverridesPath = companyId =>
  `/api/companies/${companyId}/suggestion_overrides`

export const apiFetchLearnerRecertificationTrainingsPath = (companyId, learnerId, trainingId) =>
  `/api/companies/${companyId}/learners/${learnerId}/recertifications/${trainingId}/trainings`

export const apiFetchGroupsAssignmentDataPath = (companyId, assignType) =>
  `/api/companies/${companyId}/bulk_groups/new?assign=${assignType}`

export const apiNotificationsPath = companyId => `/api/companies/${companyId}/notification`

export const apiNotifyLearnersPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/notify`

export const apiQuestionCategoryPath = (companyId, categoryId) =>
  `/api/companies/${companyId}/question_categories/${categoryId}`

export const apiOnboardingStepPath = (companyId, step) =>
  `/api/companies/${companyId}/onboardings/${step}`

export const companyOnboardingPath = (companyId, step) =>
  `/companies/${companyId}/onboardings/${step}`

export const apiRecertificationSettingsPath = companyId =>
  `/api/companies/${companyId}/recertification_settings`

export const apiRecertificationSettingsAvailableSeatsPath = companyId =>
  `/api/companies/${companyId}/recertification_settings/available_seats`

export const apiRecertificationSettingsBulkAutoAssignPath = (companyId) =>
  `/api/companies/${companyId}/recertification_settings/bulk_auto_assign`

export const apiRecertificationSettingHistoryPath = (companyId, id) =>
  `/api/companies/${companyId}/recertification_settings/${id}/history`

export const apiRecertificationSettingPath = (companyId, id) =>
  `/api/companies/${companyId}/recertification_settings/${id}`

export const apiRecertifyLearnerRecertificationPath = (companyId, learnerId, recertificationId) =>
  `/api/companies/${companyId}/learners/${learnerId}/recertifications/${recertificationId}`

export const apiRemoveJourneyStepPath = (companyId, learnerId, journeyStepId) =>
  `/api/companies/${companyId}/learners/${learnerId}/learner_trainings/${journeyStepId}`

export const apiSkipJourneyStepPath = (companyId, journeyLearnerId) =>
  `/api/companies/${companyId}/journey_learners/${journeyLearnerId}/skip`

export const apiUpdateLearnerRecertificationPath = (companyId, learnerId, recertificationId) =>
  `/api/companies/${companyId}/learners/${learnerId}/recertifications/${recertificationId}`

export const apiRemoveLearnerFromClassroomPath = (companyId, classroomId, learnerTrainingId) =>
  `/api/companies/${companyId}/classrooms/${classroomId}/learner_trainings/${learnerTrainingId}`

export const apiCompanyJourneyStepsPath = (companyId, journeyId) =>
  `/api/companies/${companyId}/journeys/${journeyId}/journey_steps`

export const apiCompanyPoliciesRecurrencePath = companyId =>
  `/api/companies/${companyId}/policies/recurrence`

export const apiCompanyPolicyPath = (companyId, policyId) =>
  `/api/companies/${companyId}/policies/${policyId}`

export const apiCampaignTemplatePreviewPath = (companyId, campaignId) =>
  `/api/companies/${companyId}/phishing_simulator/campaigns/${campaignId}/preview`

export const apiCasesPath = companyId => `/api/companies/${companyId}/cases`

export const apiCasePath = (companyId, caseId) => `/api/companies/${companyId}/cases/${caseId}`

export const apiCaseMessagesPath = (companyId, caseId) => `/api/companies/${companyId}/cases/${caseId}/messages`

export const apiCaseMessageTemplatesPath = (companyId, caseId) =>
  `/api/companies/${companyId}/cases/${caseId}/message_templates`

export const apiCaseMessageTemplatePath = (companyId, caseId, templateId) =>
  `/api/companies/${companyId}/cases/${caseId}/message_templates/${templateId}`

export const apiCreateAutoManagedCampaign = companyId =>
  `/api/companies/${companyId}/phishing_simulator/campaigns`

export const apiCreateNewLearnersGroupPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/groups`

export const apiDownloadTrainingCertificatePath = (companyId, learnerId, trainingId) =>
  `/api/companies/${companyId}/learners/${learnerId}/learner_trainings/${trainingId}/download_certificate`

export const apiDepartmentsPath = companyId => `/api/companies/${companyId}/departments`

export const apiScormsPath = companyId => `/api/companies/${companyId}/scorms`

export const apiDataReportsExportsPath = companyId => `/api/companies/${companyId}/data_reports_exports`

export const apiDuplicateCampaignPath = companyId =>
  `/api/companies/${companyId}/phishing_simulator/campaigns/duplicate`

export const apiDuplicateTrainingPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/duplicate`

export const apiCustomizeTrainingPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/customize`

export const apiClassroomPath = (companyId, classroomId) => `/api/companies/${companyId}/classrooms/${classroomId}`

export const apiCompleteClassroomPath = (companyId, classroomId) => `/api/companies/${companyId}/classrooms/${classroomId}/complete`

export const apiDuplicateClassroomPath = (companyId, classroomId) => `/api/companies/${companyId}/classrooms/${classroomId}/duplicate`

export const apiFetchClassroomsPath = companyId => `/api/companies/${companyId}/classrooms`

export const apiDashboardWidgetPath = (companyId, dashboardWidgetId) =>
  `/api/companies/${companyId}/insights/dashboard_widgets/${dashboardWidgetId}`
export const downloadClassroomCertificatesPath = (companyId, classroomId) => `/companies/${companyId}/classrooms/${classroomId}/certificates.pdf`

export const apiDashboardWidgetsPath = companyId =>
  `/api/companies/${companyId}/insights/dashboard_widgets`

export const apiDeletePaymentMethodPath = (companyId, paymentMethodId) =>
  `/api/companies/${companyId}/payment_methods/${paymentMethodId}`

export const apiPartnersPath = () => `/api/companies/partners`

export const apiPaymentMethodsPath = companyId =>
  `/api/companies/${companyId}/payment_methods`

export const apiFetchAllLearnersPath = (companyId, page, q) => {
  let query = `?phishing_simulator=true&page=${page}`

  if (q?.full_name_cont) {
    query += `&term=${encodeURIComponent(q.full_name_cont)}`
  }

  return `/api/companies/${companyId}/learners/dropdown_options${query}`
}

export const apiFetchCampaignAssignedLearnersPath = (companyId, campaignId) =>
  `/api/companies/${companyId}/phishing_simulator/campaigns/${campaignId}/insights`

export const apiFetchAllEmailTemplatesPath = companyId =>
  `/api/companies/${companyId}/phishing_simulator/email_templates`

export const apiFetchAllJourneysPath = companyId => `/api/companies/${companyId}/journeys`

export const apiFetchAssignableLearnersPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/assign`

export const apiFetchAssignableLearnersGroupsForTrainingPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/dropdown_options`

export const apiFetchAssignableLearnersGroupsPath = companyId =>
  `/api/companies/${companyId}/learners/dropdown_options`

export const apiFetchLearnerRecertificationsPath = (companyId, learnerId) =>
  `/api/companies/${companyId}/learners/${learnerId}/recertifications`

export const apiJourneyAssignedLearnersPath = (companyId, journeyId) =>
  `/api/companies/${companyId}/journeys/${journeyId}/learners/enrolled`

export const apiJourneyBulkDestroyLearnersPath = (companyId, journeyId) =>
  `/api/companies/${companyId}/journeys/${journeyId}/learners/bulk_destroy`

export const apiJourneyBulkUpdateLearnersPath = (companyId, journeyId) =>
  `/api/companies/${companyId}/journeys/${journeyId}/learners/bulk_update`

export const apiJourneyUnassignedLearnersPath = (companyId, journeyId) =>
  `/api/companies/${companyId}/journeys/${journeyId}/learners/available`

export const apiLocationsPath = companyId => `/api/companies/${companyId}/locations`

export const apiGroupsPath = companyId => `/api/companies/${companyId}/groups`

export const apiJourneyStepToggleAcknowledgmentPath = journeyStepId =>
  `/api/journey_steps/${journeyStepId}/toggle_acknowledgment`

export const apiSaveOneoffCampaignPath = (companyId, campaignId) =>
  `/api/companies/${companyId}/phishing_simulator/campaigns/${campaignId}`

export const apiSaveGroupAssignmentPath = companyId => 
  `/api/companies/${companyId}/bulk_groups/assign`

export const apiSendPricingPath = learnerUuid =>
  `/api/learners/${learnerUuid}/pricing/send_pricing`

export const apiSendTestEmailPath = (companyId, campaignId) =>
  `/api/companies/${companyId}/phishing_simulator/campaigns/${campaignId}/send_test_email`

export const apiSharePreviewPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/preview`

export const apiSetupIntentPath = companyId =>
  `/api/companies/${companyId}/payment_methods/setup_intent`

export const apiSaveGroupMembersPath = (companyId, groupId) => 
  `/api/companies/${companyId}/groups/${groupId}/update_learners`

export const apiUpdateCompanyDataPath = companyId => `/api/companies/${companyId}`

export const apiUpdatePaymentMethodPath = (companyId, paymentMethodId) =>
  `/api/companies/${companyId}/payment_methods/${paymentMethodId}/primary`

export const apiUpdateCompany = (companyId) =>
  `/api/companies/${companyId}`

export const apiCampaignsPath = companyId =>
  `/api/companies/${companyId}/phishing_simulator/campaigns`

export const apiDownloadLearnerDocumentSignaturePath = (companyId, documentId) =>
  `/api/companies/${companyId}/learner_documents/${documentId}/download`

export const apiFetchCampaignAnalysis = (companyId, campaignId) =>
  `/api/companies/${companyId}/phishing_simulator/campaigns/${campaignId}/insights`

export const apiReportAndRecommendedCampaignsPath = (companyId, reportId) =>
  `/api/companies/${companyId}/phishing_simulator/reports/${reportId}`

export const apiGetWidgetsFiltersPath = companyId => `/api/companies/${companyId}/filters`

export const apiGetAdditionalSeatsRequiredPath = companyId =>
  `/api/companies/${companyId}/licenses/additional_seats_required`

export const apiInsightsWidgetDataPath = (companyId, widgetId) =>
  `/api/companies/${companyId}/insights/widgets/${widgetId}`

export const apiInsightsWidgetActionPath = (companyId, widgetId) =>
  `/api/companies/${companyId}/insights/widgets/${widgetId}/execute_action`

export const apiInsightsDashboardsPath = companyId =>
  `/api/companies/${companyId}/insights/dashboards`

export const apiInsightsTrackingPath = companyId => `/api/companies/${companyId}/insights/tracking`

export const apiSaveWidgetsFiltersPath = (companyId, widgetId) =>
  `/api/companies/${companyId}/insights/dashboard_widgets/${widgetId}`

export const archiveCompanyJourneyPath = (companyId, journeyId) =>
  `/companies/${companyId}/journeys/${journeyId}/archive`

export const apiUpdateDashboardPath = (companyId, dashboardId) =>
  `/api/companies/${companyId}/insights/dashboards/${dashboardId}`

export const apiRecertifyLearnersPath = (companyId, learnerId) =>
  `/api/companies/${companyId}/learners/${learnerId}/recertifications/recertify_all`

export const apiRemoveLearnerDocumentPath = (companyId, documentId) =>
  `/api/companies/${companyId}/learner_documents/${documentId}`

export const apiReportBuilderPath = companyId =>
  `/api/companies/${companyId}/phishing_simulator/data_reports/report_builder`

export const apiMarkLearnerTrainingCompletePath = (companyId, learnerId, learnerTrainingId) =>
  `/api/companies/${companyId}/learners/${learnerId}/learner_trainings/${learnerTrainingId}/complete`

export const apiResetAttemptAllowancePath = (companyId, learnerId, learnerTrainingId) =>
  `/api/companies/${companyId}/learners/${learnerId}/learner_trainings/${learnerTrainingId}/reset_attempt_allowance`

export const apiBulkAttemptAllowanceResetsPath = (companyId, id = null, action = null) =>
  `/api/companies/${companyId}/bulk_learners/attempt_allowance_resets${id ? `/${id}` : ''}${action ? `/${action}` : ''}`

export const apiLearnerTrainingQuestionResultsPath = (companyId, learnerId, learnerTrainingId, format = '') =>
  `/api/companies/${companyId}/learners/${learnerId}/learner_trainings/${learnerTrainingId}/question_results${format}`

export const apiRemoveTrainingPath = (companyId, learnerId, trainingId) =>
  `/api/companies/${companyId}/learners/${learnerId}/learner_trainings/${trainingId}`

export const apiReplaceTrainingPath = (companyId, learnerId, trainingId) =>
  `/api/companies/${companyId}/learners/${learnerId}/learner_trainings/${trainingId}/replace`

export const apiStartTrainingPath = (companyId, learnerId, trainingId) =>
  `/api/companies/${companyId}/learners/${learnerId}/learner_trainings/${trainingId}/learner_redirect`

export const apiSetScoreRequirementPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/update_passing_score`

export const apiTrainingAttemptLimitPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/attempt_limit`

export const apiUpdateTrainingAttemptLimitPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/update_attempt_limit`

export const apiFetchPhishingReportsPath = companyId =>
  `/api/companies/${companyId}/phishing_simulator/reports/insights`

export const apiCreateLearnerPath = companyId => `/api/companies/${companyId}/learners`
export const apiBatchCreateLearnersPath = companyId => `/api/companies/${companyId}/learners/batch_create`

export const apiUpdateLearnersBatchPath = companyId => `/api/companies/${companyId}/learners/update_batch`

export const apiFetchLearnersFormMetadataPath = companyId =>
  `/api/companies/${companyId}/learners/form_metadata`

export const apiDeriveLearnerRegionPath = companyId =>
  `/api/companies/${companyId}/learners/derive_region`

export const apiFetchLearnerActivityHistoryPath = (companyId, learnerId) =>
  `/api/companies/${companyId}/learners/${learnerId}/activity`

export const apiFetchLearnerTrainingActivityLogPath = (companyId, learnerId, learnerTrainingId) =>
  `/api/companies/${companyId}/learners/${learnerId}/learner_trainings/${learnerTrainingId}/activity_log`

export const apiFetchRelatedCompaniesPath = companyId =>
  `/api/companies/${companyId}/related_companies`

export const apiFetchTrainingsListPath = companyId => `/api/companies/${companyId}/trainings`

export const apiFetchLearnersPortalTrainingsListPath = learnerId =>
  `/api/learners/${learnerId}/trainings`

export const apiGetLearnerTrainingPath = (learnerId, learnerTrainingId) =>
  `/api/learners/${learnerId}/learner_trainings/${learnerTrainingId}`

export const apiSelfEnrollLearnerTrainingPath = learnerId =>
  `/api/learners/${learnerId}/learner_trainings`

export const apiFetchLearnerTrainingLanguagesPath = (learnerId, trainingId) =>
  `/api/learners/${learnerId}/trainings/${trainingId}/languages`

export const apiLearnerDocumentPath = (learnerId, learnerDocumentId) =>
  `/api/learners/${learnerId}/learner_documents/${learnerDocumentId}`

export const apiFetchTrainingsFiltersPath = companyId =>
  `/api/companies/${companyId}/trainings/filters_content`

export const apiMoveLearnersToDifferentCompanyPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/learners/move`

export const apiUpdateLearnersGroupAssignmentPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/groups/update_assignments`

export const apiUpdateCompanyPath = companyId =>
  `/api/billings/companies/${companyId}`

export const apiUpdateGroupPath = (companyId, groupId) =>
  `/api/companies/${companyId}/groups/${groupId}`

export const apiUpdateLearnersTrainingsDueDatePath = companyId =>
  `/api/companies/${companyId}/bulk_learners/learners`

export const apiUpdateSubscriptionSeatsPath = (companyId, subscriptionId) =>
  `/api/companies/${companyId}/subscriptions/${subscriptionId}`

export const apiRecertifyBulkLearnersPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/learners/recertify`

export const apiUpdateTrainingPreferencesPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/learners/post_create`

export const apiUpdateBulkLearnersRecertificationPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/learner_recertifications`

export const apiUnassignTrainingsFromLearnersPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/learner_trainings`

export const apiUnassignJourneysFromLearnersPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/journeys`

export const apiPostUploadPath = (companyId, outcomeId) =>
  `/api/companies/${companyId}/learners/post_upload?outcome_id=${outcomeId}`

export const apiUpdateLearnerTainingDueDatePath = (companyId, learnerId, trainingId) =>
  `/api/companies/${companyId}/learners/${learnerId}/learner_trainings/${trainingId}`

export const apiUpdateLinkJourneyStepPath = journeyStepId =>
  `/api/journey_steps/${journeyStepId}/update_link`

export const assignTrainingsToLearnerPath = (companyId, learnerId) =>
  `/api/companies/${companyId}/learners/${learnerId}/learner_trainings`

export const allCasesPath = (companyId) => 
  `/companies/${companyId}/cases`

export const bulkArchiveLearnersPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/learners`

export const bulkLearnersNotificationsPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/notifications`

export const assignCoursesToJourneyModalFiltersPath = companyId =>
  `/api/companies/${companyId}/trainings/filters_content.json`

export const apiFetchLearnerPhishingCampaignsReportPath = (companyId, learnerId) =>
  `/api/companies/${companyId}/phishing_simulator/learners/${learnerId}/report`

export const apiFetchTrainingCategoriesPath = companyId =>
  `/api/companies/${companyId}/training_categories`

export const apiNotifyLearnerPath = (companyId, learnerId) =>
  `/api/companies/${companyId}/learners/${learnerId}/notify`

export const apiUpdateTrainingPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}`

export const apiCompanyTrainingDetailPanelPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/detail_panel`

export const apiCompanyTrainingCardPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/card`

export const apiCompanyTrainingEditModePath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/edit_mode`

export const assignDocumentsToLearnerPath = companyId =>
  `/api/companies/${companyId}/learner_documents`

export const apiBulkAssignDocumentsToLearnersPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/learner_documents`

export const apiBulkAssignLinksToLearnersPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/links`

export const assignJourneysToLearnerPath = companyId =>
  `/api/companies/${companyId}/learners/journeys`

export const apiLearnerJourneysPath = (companyId, learnerId) =>
  `/api/companies/${companyId}/learners/${learnerId}/journeys`

export const apiToggleTrainingFavoritePath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/toggle_favorite`

export const apiToggleRecommendedPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/toggle_recommended`

export const apiFetchTrainingLanguagesPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/languages`

export const apiToggleJourneyFavoritePath = (companyId, journeyId) =>
  `/api/companies/${companyId}/journeys/${journeyId}/toggle_favorite`

export const apiPublishTrainingPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/publish`

export const apiPublishDraftTrainingPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/publish_draft`

export const apiUnassignLearnerJourneyPath = (companyId, journeyId, learnerId) =>
  `/api/companies/${companyId}/journeys/${journeyId}/learners/${learnerId}`

export const apiComplianceProfileAnswersPath = companyId =>
  `/api/companies/${companyId}/compliance_profile/answers`

export const apiComplianceProfileAskAiSuggestionsPath = companyId =>
  `/api/companies/${companyId}/compliance_profile/ask_ai_suggestions`

export const apiComplianceProfileDataQualityIssuesPath = companyId =>
  `/api/companies/${companyId}/compliance_profile/data_quality_issues`

export const apiComplianceProfileExecutiveSummaryExportsPath = companyId =>
  `/api/companies/${companyId}/compliance_profile/executive_summary_exports`

export const apiComplianceProfileExecutiveSummaryExportPath = (companyId, exportId) =>
  `/api/companies/${companyId}/compliance_profile/executive_summary_exports/${exportId}`

export const apiComplianceProfileExecutiveSummaryNarrativePath = companyId =>
  `/api/companies/${companyId}/compliance_profile/executive_summary_narrative`

export const apiComplianceProfileExecutiveSummaryPath = companyId =>
  `/api/companies/${companyId}/compliance_profile/executive_summary`

export const apiComplianceProfilePath = companyId =>
  `/api/companies/${companyId}/compliance_profile`

export const apiComplianceProfileQuestionsAndGroupsPath = companyId =>
  `/api/companies/${companyId}/compliance_profile/questions`

export const apiComplianceProfileSummaryPath = companyId =>
  `/api/companies/${companyId}/compliance_profile/summary`

export const apiTrainingMandatesPath = companyId =>
  `/api/companies/${companyId}/compliance_profile/training_mandates`

export const apiTrainingNotifyRequestsPath = companyId =>
  `/api/companies/${companyId}/compliance_profile/training_notify_requests`

export const apiTrainingNotifyRequestPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/compliance_profile/training_notify_requests/${trainingId}`

export const apiMandateCourseRequestsPath = companyId =>
  `/api/companies/${companyId}/compliance_profile/mandate_course_requests`

export const apiCourseAuthoringTrainingsPath = companyId =>
  `/api/companies/${companyId}/course_authoring/trainings`

export const apiCourseAuthoringTrainingStatusPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/course_authoring/trainings/${trainingId}`

export const apiCourseAuthoringTemplatesPath = companyId =>
  `/api/companies/${companyId}/course_authoring/templates`

export const apiFetchTranslationStatusPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/course_editor/trainings/${trainingId}/translation_status`

export const bulkTrainingsOutcomePath = (companyId, outcomeId) =>
  `/api/companies/${companyId}/bulk_trainings_outcome/${outcomeId}`

export const apiBulkJourneysOutcomesPath = companyId =>
  `/api/companies/${companyId}/bulk_journeys_outcomes`

export const apiBulkJourneysOutcomePath = (companyId, outcomeId) =>
  `/api/companies/${companyId}/bulk_journeys_outcomes/${outcomeId}`

export const apiRetryBulkJourneysOutcomePath = (companyId, outcomeId) =>
  `/api/companies/${companyId}/bulk_journeys_outcomes/${outcomeId}/retry`

export const bulkUnarchiveLearnersPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/learners/unarchive`

export const bulkDeleteLearnersPermanentlyPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/learners/delete_permanently`

export const automationsPath = companyId => `/companies/${companyId}/automations`

export const apiAutomationsPath = companyId => `/api/companies/${companyId}/automations`

export const companyPath = companyId => `/companies/${companyId}`

export const companyIndexPath = companyId => `/companies/${companyId}/index`

export const companyReportBuilderPath = companyId => `/companies/${companyId}/data_reports/report_builder`

export const companyDataReportPath = (companyId, dataReportId) => `/companies/${companyId}/data_reports/${dataReportId}`

export const companyDataReportsPath = companyId => `/companies/${companyId}/data_reports`

export const companyDataReportsExportsPath = companyId => `/companies/${companyId}/data_reports_exports`

export const companyBillingPath = companyId => `/companies/${companyId}/payment_methods`

export const companyCasesPath = companyId => `/companies/${companyId}/cases`

export const companyDocumentsPath = companyId => `/companies/${companyId}/documents`

export const companyCasePath = (companyId, caseId) => `/companies/${companyId}/cases/${caseId}`

export const editCompanyCasePath = (companyId, caseId) =>
  `/companies/${companyId}/cases/${caseId}/edit`

export const exportPdfCompanyCasePath = (companyId, caseId) =>
  `/companies/${companyId}/cases/${caseId}/export_pdf`

export const auditLogCompanyCasePath = (companyId, caseId) =>
  `/companies/${companyId}/cases/${caseId}?section=audit_log`

export const transferCompanyLicensesPath = companyId => `/api/companies/${companyId}/licenses/transfer`

export const companyCampaignsPath = companyId =>
  `/companies/${companyId}/phishing_simulator/campaigns`

export const companyEditCampaignPath = (companyId, campaignId) =>
  `/companies/${companyId}/phishing_simulator/campaigns/${campaignId}/edit`

export const companySalesforcePath = (companyId, integrationId) =>
  `/companies/${companyId}/salesforce/${integrationId}`

export const companyShowCampaignPath = (companyId, campaignId) =>
  `/companies/${companyId}/phishing_simulator/campaigns/${campaignId}`

export const companyEditPath = (companyId) =>
  `/companies/${companyId}/edit?company_id=${companyId}`

export const companyInsightsDashboardPath = (companyId, dashboardId = 'current') =>
  `/companies/${companyId}/insights/dashboards/${dashboardId}`

export const companyComplianceProfilePath = companyId =>
  `/companies/${companyId}/compliance_profile`

export const companyRecertificationSettingsPath = companyId =>
  `/companies/${companyId}/recertification_settings`

export const companyGoogleDmiSendTestEmailPath = companyId =>
  `/companies/${companyId}/google_dmi/send_test_email`

export const companyIntegrationAccessTokensPath = (companyId, integrationId) =>
  `${companyIntegrationsPath(companyId)}/${integrationId}/access_tokens`

export const companyIntegrationEditPath = (companyId, integrationId) =>
  `${companyIntegrationsPath(companyId)}/${integrationId}/edit`

export const companyIntegrationPath = (companyId, integrationId) =>
  `${companyIntegrationsPath(companyId)}/${integrationId}`

export const companyIntegrationsPath = companyId => `/companies/${companyId}/integrations`

export const authorizeForStepCompanyIntegrationsPath = companyId =>
  `${companyIntegrationsPath(companyId)}/authorize_for_step`

export const companyTrainingMandatesPath = companyId =>
  `/companies/${companyId}/training_mandates`

export const companyTrainingCategoryInsightsPath = (companyId, categoryId) =>
  `/companies/${companyId}/insights/training_categories/${categoryId}`

export const companyJourneyPath = (companyId, journeyId) =>
  `/companies/${companyId}/journeys/${journeyId}`

export const companyJourneysPath = companyId => `/companies/${companyId}/journeys`

export const companyJourneyTrainingsPath = companyId => `/companies/${companyId}/journey_trainings`

export const companyMyJourneysPath = companyId => `/companies/${companyId}/my_journeys`

export const companyJourneyTemplatesPath = companyId => `/companies/${companyId}/journey_templates`

export const companyKnowledgeBaseContactPath = companyId =>
  `/companies/${companyId}/knowledge_base/contact`

export const companyTrainingsPath = companyId => `/api/companies/${companyId}/trainings.json`

export const companyMandatedJourneyPath = companyId =>
  `/api/companies/${companyId}/mandated_insights_journey`

export const companyTrainingPath = (companyId, trainingId) =>
  `/companies/${companyId}/trainings/${trainingId}`

export const companyUpgradeLmsPath = companyId =>
  `/companies/${companyId}/payment_methods?mode=upgrade_lms&plan_package=lms_package&upgrade=true`

export const apiEnableCustomizationCompanyTrainingPath = (companyId, customTrainingId) =>
  `/api/companies/${companyId}/trainings/${customTrainingId}/enable_customization`

export const apiDisableCustomizationCompanyTrainingPath = (companyId, customTrainingId) =>
  `/api/companies/${companyId}/trainings/${customTrainingId}/disable_customization`

export const courseAuthoringTrainingsPath = companyId =>
  `/companies/${companyId}/course_authoring/trainings`

export const courseAuthoringTemplatesPath = companyId =>
  `/companies/${companyId}/course_authoring/templates`

export const courseAuthoringTrainingPath = (companyId, trainingId) =>
  `/companies/${companyId}/course_authoring/trainings/${trainingId}/edit`

export const editCompanyTrainingContentPath = (companyId, trainingId, editMode) => {
  const path = `/companies/${companyId}/trainings/${trainingId}/edit_content`
  return editMode ? `${path}?edit_mode=${encodeURIComponent(editMode)}` : path
}

export const courseAuthoringRequestDraftPath = (companyId, trainingId) =>
  `/companies/${companyId}/course_authoring/trainings/${trainingId}/request_draft`

export const courseAuthoringTrainingShowPath = (companyId, trainingId) =>
  `/companies/${companyId}/course_authoring/trainings/${trainingId}`

export const apiCourseAuthoringDraftStatusPath = (companyId, trainingId, editMode) => {
  const path = `/api/companies/${companyId}/course_authoring/trainings/${trainingId}/draft_status`
  return editMode ? `${path}?edit_mode=${encodeURIComponent(editMode)}` : path
}

export const apiScormImportStatusPath = (companyId, trainingId) =>
  `/api/companies/${companyId}/trainings/${trainingId}/post_create`

export const customizeTrainingPath = (companyId, trainingId) =>
  `/companies/${companyId}/trainings/${trainingId}/wizard_new`

export const createBulkTrainingsPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/learner_trainings`

export const classroomsListPath = companyId => `/companies/${companyId}/classrooms`

export const downloadCertificatesCompanyJourneyPath = (companyId, journeyId) =>
  `/companies/${companyId}/journeys/${journeyId}/download_certificates`

export const downloadCertificatesLearnersPath = companyId =>
  `/api/companies/${companyId}/bulk_learners/certificates`

export const duplicateCompanyJourneyPath = (companyId, journeyId) =>
  `/companies/${companyId}/journeys/${journeyId}/duplicate`

export const deleteCompanyLogoPath = companyId => `/companies/${companyId}/delete_logo`

export const deleteLearnerPath = (companyId, learnerId) =>
  `/api/companies/${companyId}/learners/${learnerId}`

export const deleteLearnerPermanentlyPath = (companyId, learnerId) =>
  `/api/companies/${companyId}/learners/${learnerId}/delete_permanently`

export const documentsPath = companyId => `/api/companies/${companyId}/documents`

export const editCompanyJourneyPath = (companyId, journeyId) =>
  `/companies/${companyId}/journeys/${journeyId}/edit`

export const editInSettingsPath = companyId => `/companies/${companyId}/due_date`

export const editTrainingPath = (companyId, trainingId) =>
  `/companies/${companyId}/trainings/${trainingId}/edit`

export const fetchCadencePath = companyId => `/api/companies/${companyId}/trainings/cadence`

export const fetchPassingScorePath = companyId =>
  `/api/companies/${companyId}/trainings/passing_score`

export const fetchLearnerDetailsPath = (companyId, learnerId) =>
  `/api/companies/${companyId}/learners/${learnerId}`

export const fetchAvailableLocalesPath = companyId =>
  `/api/companies/${companyId}/course_editor/translation_requests/available_locales`

export const getEmailPlatformsPath = companyId =>
  `/api/companies/${companyId}/phishing_simulator/communication_methods`

export const getIndustriesPath = companyId =>
  `/api/companies/${companyId}/phishing_simulator/industries`

export const getCampaignsPath = companyId => `/companies/${companyId}/phishing_simulator/campaigns`

export const getLandingPagePath = (companyId, campaignId, emailTemplateId) =>
  `/companies/${companyId}/phishing_simulator/campaigns/${campaignId}/email_templates/${emailTemplateId}`

export const groupsTabPath = companyId => `/companies/${companyId}/groups`

export const journeyLearnersPath = (companyId, journeyId) =>
  `/companies/${companyId}/journeys/${journeyId}/learners`

export const learnerMyJourneysPath = learnerUUID => `/learners/${learnerUUID}/journey_learners`

export const learnerDrawerPath = (companyId, learnerUUID) =>
  `/companies/${companyId}/learners?learner_id=${learnerUUID}`

export const learnerDrawerWithFiltersPath = (companyId, departmentId) =>
  `/companies/${companyId}/learners?q[department_id_in][]=${departmentId}&commit=Apply`

export const learnersFilterPath = (companyId, filterKey, filterId) =>
  `/companies/${companyId}/learners?q[${filterKey}_id_in]=${filterId}`

export const learnerLearnerLinkPath = (learnerUUID, linkUUID) =>
  `/learners/${learnerUUID}/learner_links/${linkUUID}`

export const learnerTabPath = companyId => `/companies/${companyId}/learners`

export const learnerAssignedTrainingsPath = (companyId, trainingId) =>
  `/companies/${companyId}/learners?q[with_assigned_trainings][]=training_${trainingId}`

export const learnersPortalIndexPath = learnerId => `/learners/${learnerId}/trainings`

export const proTipRedirectPath = companyId => `/companies/${companyId}/journeys/pro_tip_redirect`

export const redirectLearnerLearnerLinkPath = (learnerUUID, linkUUID) =>
  `/learners/${learnerUUID}/learner_links/${linkUUID}/redirect`

export const phishingReportPath = companyId => `/companies/${companyId}/phishing_simulator/reports`

export const publishCompanyJourneyPath = (companyId, journeyId) =>
  `/api/companies/${companyId}/journeys/${journeyId}`

export const publishCampaignPath = (companyId, campaignId) =>
  `/api/companies/${companyId}/phishing_simulator/campaigns/${campaignId}/publish`

export const publicKioskLinkRedirectPath = secretId => `/k/${secretId}/redirect`

export const publicKioskLinkLearnersPath = secretId => `/k/${secretId}/learners`

export const phishingSimulatorReportsPath = companyId =>
  `/companies/${companyId}/phishing_simulator/reports`

export const previewLearners = (companyId, campaignId) => {
  let query = ''
  if (campaignId) {
    query = `?q[campaigns_id_eq]=${campaignId}`
  }
  return `/companies/${companyId}/learners${query}`
}

export const saveTranslationRequestsPath = companyId =>
  `/api/companies/${companyId}/course_editor/translation_requests`

export const trainingsCatalogPath = companyId => `/companies/${companyId}/trainings`

export const trainingsCatalogHomePath = companyId => `/companies/${companyId}/trainings/home`

export const toggleJourneyFavoritePath = (companyId, journeyId) =>
  `/companies/${companyId}/journeys/${journeyId}/toggle_favorite`

export const showLearnerPath = (companyId, learnerId) =>
  `/api/companies/${companyId}/learners/${learnerId}`

export const toggleTrainingFavoritePath = (companyId, trainingId) =>
  `/companies/${companyId}/trainings/${trainingId}/toggle_favorite`

export const trainingPath = (companyId, trainingId) =>
  `/companies/${companyId}/trainings/${trainingId}`

export const upgradeCompanyPath = companyId => `/companies/${companyId}/payment_methods`

export const updateLearnerColumnPreferencesPath = companyId =>
  `/api/companies/${companyId}/table_settings`

export const checkLowBalancePath = companyId => `/api/companies/${companyId}/low_balance`

export const apiHelplineSettingPath = companyId => `/api/companies/${companyId}/helpline_setting`

export const viewWhitelistingSetupPagePath = `https://help.easyllama.com/easyllama-security-awareness-training-and-phishing-simulator#allow-emails-for-phishing-simulator`

export const apiTrackingEventsPath = companyId =>
  `/api/companies/${companyId}/tracking/events`

// Organize routes in alphabetical order
